// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pbgI","col":"styles_col__2pAS8"};